import React from 'react'
import styled from 'styled-components'

import DesktopNav from './DesktopNav/DesktopNav';
import MobileNav from './MobileNav/MobileNav';

const StyledNavs = styled.div`


@media (max-width: 1200px) {
    &>nav:nth-child(1) {
        display: none;
    }
}
@media (min-width: 1200px) {
    &>nav:nth-child(2) {
        display: none;
    }
}
`;


export default function NavBar({ className }) {
    return (
        <div className={className}>
            <StyledNavs>
                <DesktopNav />
                <MobileNav />
            </StyledNavs>
        </div>
    )
}
